import * as React from 'react';
import PropTypes from "prop-types";
import {FormGroup, Label, Col, FormFeedback, Input, Alert} from "reactstrap";
import Select from "react-select";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {isEmpty} from "lodash";
import {useTranslation} from "react-i18next";

export const DOCUMENTS_TYPE_INVOICE = 'invoice';
export const DOCUMENTS_TYPE_DELIVERY = 'delivery';
export const DOCUMENTS_TYPE_REQUISITION = 'requisition';
export const DOCUMENT_STATUS_ACCEPTED = 'ACCEPTED';
export const DOCUMENT_STATUS_CONFIRMED = 'CONFIRMED';
export const DOCUMENT_STATUS_COMPLETED = 'COMPLETED';

export const DocumentsTypeSelect = (props) => {
  const { t } = useTranslation('supplier_create')
  const [value, setValue] = React.useState(props.value);

  useAfterUpdateEffect(() => {
    if(value !== props.value){
      setValue(props.value)
    }
  }, [props.value])

  const options = [
    {
      label: t(`supplier.interCars.documents_type_select.${DOCUMENTS_TYPE_REQUISITION}`),
      value: DOCUMENTS_TYPE_REQUISITION,
    },
    {
      label: t(`supplier.interCars.documents_type_select.${DOCUMENTS_TYPE_DELIVERY}`),
      value: DOCUMENTS_TYPE_DELIVERY,
    },
    {
      label: t(`supplier.interCars.documents_type_select.${DOCUMENTS_TYPE_INVOICE}`),
      value: DOCUMENTS_TYPE_INVOICE,
    },
  ]

  return <Select
    options={options}
    value={options.find(o => o.value === value)}
    placeholder={t('common:select.placeholder')}
    onChange={option => {
      setValue(option.value);
      props.onChange(option.value);
    }}
  />
}

export const DocumentStatusSelect = (props) => {
  const { t } = useTranslation('supplier_create')
  const [value, setValue] = React.useState(props.value);

  useAfterUpdateEffect(() => {
    if(value !== props.value){
      setValue(props.value)
    }
  }, [props.value])

  const options = [
    {
      label: t(`supplier.interCars.document_status_select.${DOCUMENT_STATUS_ACCEPTED}.name`),
      value: DOCUMENT_STATUS_ACCEPTED,
    },
    {
      label: t(`supplier.interCars.document_status_select.${DOCUMENT_STATUS_CONFIRMED}.name`),
      value: DOCUMENT_STATUS_CONFIRMED,
    },
    {
      label: t(`supplier.interCars.document_status_select.${DOCUMENT_STATUS_COMPLETED}.name`),
      value: DOCUMENT_STATUS_COMPLETED,
    },
  ]

  return <Select
    options={options}
    value={options.find(o => o.value === value)}
    placeholder={t('common:select.placeholder')}
    onChange={option => {
      setValue(option.value);
      props.onChange(option.value);
    }}
  />
}

function SupplierInterCarsFields(props) {
  const { t } = useTranslation('supplier_create')

  useDidMountEffect(() => {
    let updateObj = {}
    if(!props.data.documentsType){
      updateObj.documentsType = DOCUMENTS_TYPE_REQUISITION
    }
    if(!props.data.documentStatus){
      updateObj.documentStatus = DOCUMENT_STATUS_CONFIRMED
    }

    if(!isEmpty(updateObj)){
      props.onChangeData(updateObj)
    }
  })

  return (
    <React.Fragment>
      <FormGroup row>
        <Label md={3}>ClientId</Label>
        <Col md="9">
          <Input invalid={!!props.errors.clientId?.errors} placeholder="clientId" onChange={e => props.onChangeData({clientId: e.target.value})} value={props.data.clientId || ''} />
          <FormFeedback>{props.errors.clientId?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>ClientSecret</Label>
        <Col md="9">
          <Input invalid={!!props.errors.clientSecret?.errors} placeholder="clientSecret" onChange={e => props.onChangeData({clientSecret: e.target.value})} value={props.data.clientSecret || ''} />
          <FormFeedback>{props.errors.clientSecret?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier.interCars.documents_type')}</Label>
        <Col md="9">
          <DocumentsTypeSelect
            value={props.data.documentsType}
            onChange={documentsType => props.onChangeData({documentsType})}
          />
          <FormFeedback>{props.errors.documentsType?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      {props.data.documentsType === DOCUMENTS_TYPE_REQUISITION && <FormGroup row>
        <Label md={3}>{t('supplier.interCars.document_status')}</Label>
        <Col md="9">
          <DocumentStatusSelect
            value={props.data.documentStatus}
            onChange={documentStatus => props.onChangeData({ documentStatus })}
          />
          {props.errors.documentStatus?.errors && <FormFeedback className="d-flex">{props.errors.documentStatus?.errors?.join('; ')}</FormFeedback>}
          {props.data.documentStatus && <Alert color={'info'} className="mt-2 p-2 d-flex flex-row flex-nowrap align-items-center">
            <i className="fas fa-info-circle fa-2x mr-2" />
            <span>{t(`supplier.interCars.document_status_select.${props.data.documentStatus}.description`)}</span>
          </Alert>}
        </Col>
      </FormGroup>}
    </React.Fragment>
  );
}

SupplierInterCarsFields.propTypes = {
  onChangeData: PropTypes.func.isRequired,
  data: PropTypes.shape({
    clientId: PropTypes.string,
    clientSecret: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
};

export default SupplierInterCarsFields;